import React from 'react';
import ProjectsCards from '../components/projects/ProjectsCards';
const ProjectsPage = () => {
    return (
        <>
        <ProjectsCards/>
            {/* <Clients /> */}
        </>
    );
};

export default ProjectsPage;